import { Drawer } from '@cleartax/wg-library-drawer';
import { TCategories } from '..';
import { THeader } from '../../../../../../../pages/services/[planSeoSlug]/api/types';
import { geHeaderCategory } from '../../utils';
import { SidebarDropDown } from '../hamburger-sidebar/sidebar-dropdown';

interface INavSidebar {
  open: boolean;
  closeCB: () => void;
  categorySelected: TCategories;
  headerData: THeader;
}
export const NavSidebar: React.FC<INavSidebar> = ({
  open,
  closeCB,
  categorySelected,
  headerData,
}) => {
  const categoryToShow = geHeaderCategory(headerData, categorySelected);
  return (
    <Drawer
      onCloseCallBack={() => closeCB()}
      isOpen={open}
      direction={'right'}
      width={'4/5'}
      minWidth={300}
      animationDuration={500}
      top={'80px'}
      hideIcon={true}
      closeOnClickOverlay={true}
    >
      {categoryToShow
        ? categoryToShow.subMenu.map((category) => {
            return (
              <SidebarDropDown
                key={category.categoryId}
                headerClasses={'text-s-14 text-brand-1000 mb-4 font-medium'}
                contentArr={category.subMenu.map((subCategory) => {
                  return {
                    name: subCategory.name,
                    href: `/services/${subCategory.seoSlug}/c`,
                  };
                })}
                contentHeader={category.name}
              />
            );
          })
        : null}
    </Drawer>
  );
};
